const subscriptionInvoicesKeys = {
  // Section Headers
  "subscription.invoices.title": "Invoices",

  // Table Headers
  "subscription.invoices.column.date": "Date",
  "subscription.invoices.column.description": "Description",
  "subscription.invoices.column.amount": "Amount",
  "subscription.invoices.column.status": "Status",
  "subscription.invoices.column.receipt": "Receipt",

  // Invoice Descriptions
  "subscription.invoices.description.other": "Other",
  "subscription.invoices.description.new": "New {{interval}} subscription: {{quantity}} seats",
  "subscription.invoices.description.update": "{{previousInterval}} subscription updated to {{interval}}: {{quantity}} seats {{action}}",
  "subscription.invoices.description.update.simple": "Subscription updated: {{quantity}} seats {{action}}",
  "subscription.invoices.description.cycle": "{{interval}} payment: {{quantity}} seats",

  // Interval Types - Using direct API values
  "subscription.invoices.interval.month": "Monthly",
  "subscription.invoices.interval.year": "Annual",

  // Actions
  "subscription.invoices.action.added": "added",
  "subscription.invoices.action.removed": "removed",

  // Receipt
  "subscription.invoices.receipt.pdf": "PDF",
  "subscription.invoices.receipt.na": "N/A",
};

export const subscriptionInvoices = {
  ...subscriptionInvoicesKeys,
};
